/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Plan_Feat1Inputs */

const en_builder_plan_feat1 = /** @type {(inputs: Builder_Plan_Feat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20 verified steps / month (≈ one small app)`)
};

const id_builder_plan_feat1 = /** @type {(inputs: Builder_Plan_Feat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20 langkah terverifikasi / bulan (≈ satu aplikasi kecil)`)
};

/**
* | output |
* | --- |
* | "20 verified steps / month (≈ one small app)" |
*
* @param {Builder_Plan_Feat1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const builder_plan_feat1 = /** @type {((inputs?: Builder_Plan_Feat1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Plan_Feat1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builder_plan_feat1(inputs)
	return en_builder_plan_feat1(inputs)
});